import styles from "./VerifyNumber.module.css";
import { useState, useRef, useEffect } from "react";

import chevronLeft from "../../asset/icons/chevronLeft.png"
import cx from 'classnames';
import Api from "../../utils/Api/Api";
import { LoginSignupCommon } from "../../commonComponents";
import { useNavigate } from "react-router-dom";
import { usePostHog } from 'posthog-js/react';
import SnapchatPixel from '../../utils/SnapchatPixel';
import * as amplitude from '@amplitude/analytics-browser';
import { trackAuthEvent, trackCustomEvent, AUTH_EVENT_TYPES, CUSTOM_EVENTS, ANALYTICS_PROVIDERS } from '../../utils/analyticsService';

export const VerifyNumber = () => {
    const navigate = useNavigate()
    const posthog = usePostHog();

    const [otpArray, setOtpArray] = useState(["", "", "", ""]);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isfilled,setIsFilled] = useState(false)
    const [timer, setTimer] = useState(30);
    const input1 = useRef();
    const input2 = useRef();
    const input3 = useRef();
    const input4 = useRef();
    const arrayOfRef = [input1, input2, input3, input4];

    const onKeyDown = (e) => {
        const idx = Number(e.target.getAttribute("idx"));
        const value = e.target.value;
        if (e.code === "Backspace" && value === "") {
            if (idx !== 0) {
                setOtpArray((pre_array) => {
                    return pre_array.map((ele, i) => (
                        i + 1 === idx ? "" : ele
                    ))
                })
                arrayOfRef[idx - 1].current.focus();
            }
            if(isfilled){
                setIsFilled(false)
            }
        }
    }

    const handleErrorClick = (e) => {
        if (error) {
            const idx = Number(e.target.getAttribute("idx"));
            setOtpArray((pre_array) => {
                return pre_array.map((ele, i) => (
                    i >= idx ? "" : ele
                ))
            })

        }
    }

    const handleChange = (e) => {
        const idx = Number(e.target.getAttribute("idx"));
        const value = e.target.value;
        if (error) {
            setError(false);
            setErrorMessage("");
        }
        setOtpArray((pre_array) => {
            return pre_array.map((ele, i) => (
                i !== idx ? ele : value.slice(value.length - 1)
            ))
        })
        if (value === "") {
            if (idx !== 0) {
                arrayOfRef[idx - 1].current.focus();
            }
        }
        else {
            if (idx !== 3) {
                arrayOfRef[idx + 1].current.focus();
            }
        }
        if(idx===3){
            if(otpArray[0] && otpArray[1] && otpArray[2] && value){
                setIsFilled(true)
            }
            else{
                setIsFilled(false)
            }
        }
        else if(idx!==3){
            if(isfilled){
                setIsFilled(false)
            }
        }
    };

    const handleStyle = (idx) => {
        if (error) {
            return cx(styles.otpBox, styles.error)
        }
        else {
            if (otpArray[idx] !== "") {
                return cx(styles.otpBox, styles.filled)
            }
            else {
                return styles.otpBox;
            }
        }
    }

    const submitButtonClass = () => {

        if (otpArray[0] && otpArray[1] && otpArray[2] && otpArray[3]) {
            if (error) {
                return styles.otpButton
            }
            else {
                return cx(styles.otpButton, styles.active);
            }
        }
        else {
            return styles.otpButton
        }
    }

    useEffect(() => {
        let timeout = setTimeout(() => {
            if (timer !== 0) {
                setTimer((pre_state) => (pre_state - 1))
            }
        }, 1000);
        return (() => {
            clearTimeout(timeout);
        })
    }, [timer])

    useEffect(() => {
        const checkIfFilled = () => {
            if (otpArray[0] && otpArray[1] && otpArray[2] && otpArray[3] && !error) {
                VerifyOtp()
            }
        }
        checkIfFilled()
    },[isfilled])

    useEffect(() => {
        arrayOfRef[0].current.focus();
    }, []);

    const phoneNo = localStorage.getItem('phoneNo');

    // Track OTP Verification Page Viewed
    useEffect(() => {
        // Use centralized analytics for OTP page view (Amplitude only)
        trackCustomEvent(CUSTOM_EVENTS.CONTENT_VIEWED, {
            content_type: 'otp_verification_page',
            phone_number_length: phoneNo?.length || 0,
            login_trigger: localStorage.getItem("returnToPage") ? 'checkout_flow' : 'direct_navigation',
            return_page: localStorage.getItem("returnToPage") || null,
            pending_action: localStorage.getItem("pendingAction") || null
        }, ANALYTICS_PROVIDERS.AMPLITUDE);
    }, [phoneNo]);

    const VerifyOtp = async () => {
        try {
            const { data } = await Api.VerifyOtp({ phone: phoneNo, otp: Number(otpArray.join('')) });
            console.log("data from verify otp",data)
            if (data && data.access_token) {
                localStorage.setItem('accesstoken', data.access_token);
                
                // Get context for login tracking
                const returnToPage = localStorage.getItem("returnToPage");
                const pendingAction = localStorage.getItem("pendingAction");
                const loginTrigger = returnToPage ? 'checkout_flow' : 'direct_navigation';
                
                // AMPLITUDE USER IDENTIFICATION AND LOGIN TRACKING
                // Set user ID and properties in Amplitude
                amplitude.setUserId(phoneNo);
                
                // Create identify object and set properties
                const identifyObj = new amplitude.Identify()
                    .set('phone', phoneNo)
                    .set('login_method', 'phone_otp')
                    .set('currency_type', localStorage.getItem('current_currency_type') || 'INR')
                    .set('last_login', new Date().toISOString())
                    .setOnce('first_login', new Date().toISOString())
                    .setOnce('initial_currency', localStorage.getItem('current_currency_type') || 'INR');
                
                amplitude.identify(identifyObj);
                
                // Track Login Success
                // Use centralized analytics for login success (Amplitude only)
                trackCustomEvent(CUSTOM_EVENTS.BUTTON_CLICKED, {
                    button_name: 'Login Success',
                    method: 'phone_otp',
                    login_trigger: loginTrigger,
                    return_page: returnToPage || null,
                    pending_action: pendingAction || null,
                    phone_number_length: phoneNo?.length || 0,
                    is_checkout_flow: returnToPage ? true : false
                }, ANALYTICS_PROVIDERS.AMPLITUDE);
                
                // Use centralized analytics for login success (handles Facebook, Snapchat, etc.)
                trackAuthEvent(AUTH_EVENT_TYPES.LOGIN, {
                    phone: phoneNo,
                    method: 'phone_otp',
                    return_page: returnToPage || null,
                    pending_action: pendingAction || null
                });
                
                // Identify user in PostHog
                if (posthog) {
                    const posthogIdentify = posthog.identify(phoneNo, {
                        phone: phoneNo,
                        login_type: 'phone_otp',
                        currency_type: localStorage.getItem('current_currency_type') || 'inr',
                        last_login: new Date().toISOString(),
                        $set_once: { 
                            first_login: new Date().toISOString(),
                            initial_currency: localStorage.getItem('current_currency_type') || 'inr'
                        }
                    });

                    console.log("Captured and Identified User",posthogIdentify)
                    
                    // Track successful login
                    posthog.capture('user_logged_in', {
                        login_method: 'phone_otp',
                        phone: phoneNo
                    });
                }

                // Enhanced redirect logic with support for pending actions
                if (returnToPage) {
                    console.log("Redirecting to previously saved page:", returnToPage);
                    
                    // If there was a pending action like "addToCart"
                    if (pendingAction === "addToCart") {
                        const pendingDetails = JSON.parse(localStorage.getItem("pendingActionDetails") || "{}");
                        // We'll handle the pending action after redirect
                        
                        // Clean up storage but keep brandId for compatibility
                        localStorage.removeItem("pendingAction");
                        localStorage.removeItem("pendingActionDetails");
                        
                        // Navigate to the saved page
                        navigate(returnToPage);
                        localStorage.removeItem("returnToPage");
                    } else {
                        // Simple redirect without pending action
                        navigate(returnToPage);
                        localStorage.removeItem("returnToPage");
                        localStorage.removeItem("brandId"); // Clean up for compatibility
                    }
                } else if (localStorage.getItem("brandId")) {
                    // Legacy support for older flow
                    navigate(`/brand/${localStorage.getItem("brandId")}`);
                    localStorage.removeItem("brandId");
                } else {
                    // Default redirect to marketplace
                    navigate("/marketplace");
                }
            } else {
                // Track Login Failed - Invalid OTP
                // Use centralized analytics for login failure - Invalid OTP (Amplitude only)
                trackCustomEvent(CUSTOM_EVENTS.BUTTON_CLICKED, {
                    button_name: 'Login Failed',
                    method: 'phone_otp',
                    failure_reason: 'invalid_otp',
                    login_trigger: localStorage.getItem("returnToPage") ? 'checkout_flow' : 'direct_navigation',
                    return_page: localStorage.getItem("returnToPage") || null,
                    pending_action: localStorage.getItem("pendingAction") || null,
                    phone_number_length: phoneNo?.length || 0,
                    success: false
                }, ANALYTICS_PROVIDERS.AMPLITUDE);
                
                setError(true);
                setErrorMessage("Invalid OTP. Please try again.");
                setOtpArray(["", "", "", ""]);
                arrayOfRef[0].current.focus();
            }
        } catch (err) {
            console.error("OTP Verification Error:", err);
            
            // Track Login Failed - API Error
            // Use centralized analytics for login failure - API Error (Amplitude only)
            trackCustomEvent(CUSTOM_EVENTS.BUTTON_CLICKED, {
                button_name: 'Login Failed',
                method: 'phone_otp',
                failure_reason: 'api_error',
                error_message: err?.response?.data?.error || 'Unknown error',
                login_trigger: localStorage.getItem("returnToPage") ? 'checkout_flow' : 'direct_navigation',
                return_page: localStorage.getItem("returnToPage") || null,
                pending_action: localStorage.getItem("pendingAction") || null,
                phone_number_length: phoneNo?.length || 0,
                success: false
            }, ANALYTICS_PROVIDERS.AMPLITUDE);
            
            setError(true);
            setErrorMessage(err?.response?.data?.error || "Invalid OTP. Please try again.");
            setOtpArray(["", "", "", ""]);
            arrayOfRef[0].current.focus();
            setIsFilled(false);
        }
    };

    const GetOtp = async () => {
        await Api.GetOtp({ phone: phoneNo });
        setTimer(30)
    }

    return (
        <div className={styles.content}>
            <div className={styles.elements}>
                <div className={styles.mobileContent}>
                    <img onClick={() => navigate(-1)} className={styles.chevron} src={chevronLeft} alt="chevronLeft" />
                    <p className={styles.title}>Verify your number </p>
                    <p className={styles.subTitle}>We have sent an OTP to +91 {phoneNo}</p>
                </div>
                <LoginSignupCommon title={"Verify your number"} subtitile={`We have sent an OTP to +91 ${phoneNo}`} />
                <div className={styles.otpContainer}>
                    {
                        otpArray.map((_, idx) => (
                            <input type={"number"} onKeyDown={onKeyDown} onClick={handleErrorClick} onChange={handleChange} className={handleStyle(idx)} key={idx} ref={arrayOfRef[idx]} idx={idx} value={otpArray[idx]} />
                        ))
                    }
                </div>
                {error && <p className={styles.incorrectText}>{errorMessage || "Incorrect OTP, Try again!"}</p>}
                {
                    timer === 0 ?
                        <p onClick={GetOtp} className={styles.subText}>
                            Didn't receive? <span className={styles.resendText}>RESEND CODE</span>
                        </p>
                        :
                        <p className={styles.subText}>
                            Request a new OTP in 00:{timer < 10 ? "0" + timer : timer}
                        </p>

                }
                <button disabled={error} onClick={VerifyOtp} className={submitButtonClass()}>CONFIRM OTP</button>
            </div>

        </div>
    )
}

